/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_ChangedInputs */



/**
* | output |
* | --- |
* | "This contract was changed after you opened it. The page now shows the current terms — check them and decide again." |
*
* @param {Partner_Org_Contract_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_changed = /** @type {((inputs?: Partner_Org_Contract_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Vertrag wurde geändert, nachdem Sie ihn geöffnet haben. Die Seite zeigt jetzt die aktuellen Bedingungen — prüfen Sie diese und entscheiden Sie erneut.")
	return /** @type {LocalizedString} */ ("This contract was changed after you opened it. The page now shows the current terms — check them and decide again.")
});